"use client";

import { useEffect, useState } from "react";

export type CookiebotConsent = {
  marketing: boolean;
  necessary: boolean;
  preferences: boolean;
  statistics: boolean;
};

export type CookieBot = {
  consent: CookiebotConsent;
  hasResponse: boolean;
};

export const useMarketingConsent = () => {
  const [hasConsent, setHasConsent] = useState(false);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const checkConsent = () => {
      if (typeof window === "undefined") return;

      // Check if Cookiebot already has a response
      if (window.Cookiebot?.hasResponse) {
        setHasConsent(window.Cookiebot.consent.marketing);
        setIsReady(true);
      }
    };

    const handleConsentReady = () => {
      if (typeof window === "undefined") return;

      setHasConsent(window.Cookiebot?.consent?.marketing || false);
      setIsReady(true);
    };

    // Check immediately if Cookiebot is already loaded
    checkConsent();

    // Listen for consent updates
    window.addEventListener("CookiebotOnConsentReady", handleConsentReady);

    return () => {
      window.removeEventListener("CookiebotOnConsentReady", handleConsentReady);
    };
  }, []);

  return { hasConsent, isReady };
};
